// extracted by mini-css-extract-plugin
export var borderRadius = "_g1-4";
export var large = "_g1-3";
export var logoContainer = "_g1-0";
export var nameLogo = "_g1-2";
export var small = "_g1-1";